import { formatCurrency } from "../../../../../formatters";
import { BrandMtdRow } from "../../../../../Brands/brandsApiMapping";
import MobileBarChart from "../../../../MobileBarChart";

interface BrandsIncomeChartProps {
  rows: BrandMtdRow[];
}

// Mobile's replacement for the desktop BrandsIncomeChart.tsx - same data/
// colors, via MobileBarChart (static value labels) instead of the desktop's
// hover-tooltip pattern (see MobileBarChart.tsx).
export default function BrandsIncomeChart({ rows }: BrandsIncomeChartProps) {
  return (
    <MobileBarChart
      title="Total income by brand (MTD)"
      data={rows.map((row) => ({ label: row.brand.replace(" Optifund", ""), value: row.income }))}
      color="#8E24AA"
      barLabelFormatter={formatCurrency}
    />
  );
}
